import React from "react";
import PropTypes from "prop-types";
// import videojs from 'video.js/dist/video.min.js';
// import 'video.js/dist/video-js.css';
import Request from '../../utils/request';
import utils from "../../utils/utils";
import px2rem from "../../utils/px2rem";
import "./style.less";

class PipelineVideo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFullScreen: false,
    };
    this.playerSdk = null;
    this.isFirstPlay = true;
  }

  componentDidMount() {
    if (!window.VePlayer) {
      this.loadVeplayerCss();
      this.loadVeplayerScript('https://sh1.shihuocdn.cn/app/js/veplayer/veplayer.min.js', () => {
        this.initVideo();
      });
    } else {
      this.initVideo();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.playerState === 'pause') {
      // 暂停播放
      this.handleVideoPause();
    } else if (nextProps.playerState === 'play') {
      if (this.playerSdk && this.playerSdk.player && this.playerSdk.player.state == 6) {
        // 继续播放
        this.handleVideoPlay();
      }
    }
  }

  // 加载字节播放器css文件
  loadVeplayerCss = () => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://sh1.shihuocdn.cn/app/css/veplayer/veplayer.min.css';
    document.head.appendChild(link);
  }

  // 加载字节播放器sdk
  loadVeplayerScript = (url, callback) => {
    const script = document.createElement('script');
    script.src = url;
    // 添加加载完成的回调函数
    script.onload = callback;
    document.body.appendChild(script);
  }

  // 初始化播放器
  async initVideo() {
    const videoInfo = this.props.config.video;
    const { url = '', poster = '', vid = '' } = videoInfo;
    const videoId = `${this.props['customAttributes']['data-component-id']}`;
    const playOption = {}

    if (!vid) {
      Object.assign(playOption, {
        id: videoId,
        url: url,
        poster: `${poster}?imageslim|imageMogr2/interlace/1`,
        streamType: 'mp4',
        autoplay: false,
        loop: false,
        fullscreen: {
          useCssFullscreen: true,
        }
      })
    } else {
      const { playAuthToken } = await this.getPlayAuthToken(vid);
      Object.assign(playOption, {
        id: videoId,
        poster: `${poster}?imageslim|imageMogr2/interlace/1`,
        streamType: 'mp4',
        autoplay: false,
        loop: false,
        fullscreen: {
          useCssFullscreen: true,
        },
        getVideoByToken: {
          playAuthToken: playAuthToken
        },
        onTokenExpired: () => {
          return new Promise(resolve => {
            // 调用您的接口获取新的 playAuthToken
            Request({
              url: `https://upload.shihuo.cn/v1/media/getPlayToken`,
              method: 'get',
              withCredentials: true,
              headers: {
                platform: 'h5'
              },
              params: {
                vid: vid,
                expire: 300
              },
            }).then(res => {
              const { status, data } = res.data;
              if (status === 0) {
                resolve({
                  playAuthToken: data.play_token, // 新的 playAuthToken
                })
              }
            })
          });
        }
      })
    }

    this.playerSdk = new window.VePlayer(playOption);

    this.playerSdk.on('play', () => {
      // 视频开始播放埋点
      if (this.isFirstPlay) {
        let pageId = 0;
        if (window.location.host === 'zt-public.shihuo.cn') {
          pageId = window.location.pathname.split('/')[2];
        }
        // eslint-disable-next-line no-undef
        __dace.sendEvent("pipeline-video", {
          id: pageId,
        });

        utils.uploadTrack(this.props);
        this.isFirstPlay = false;
      }
    });
  }

  // 获取PlayAuthToken
  getPlayAuthToken = (vid) => {
    return new Promise(resolve => {
      // 调用您的接口获取新的 playAuthToken
      Request({
        url: `https://upload.shihuo.cn/v1/media/getPlayToken`,
        method: 'get',
        withCredentials: true,
        headers: {
          platform: 'h5'
        },
        params: {
          vid: vid,
          expire: 300
        },
      }).then(res => {
        const { status, data } = res.data;
        if (status === 0) {
          resolve({
            playAuthToken: data.play_token, // 新的 playAuthToken
          })
        }
      })
    });
  }

  // 禁用自动全屏
  disableFullScreenAuto() {
    const videoTag = document.querySelector(`#${this.props['customAttributes']['data-component-id']}`).getElementsByTagName('video');
    const video = videoTag && videoTag[0];
    if (video) {
      video.setAttribute('playsinline', true)
      video.setAttribute('x5-playsinline', true)
      video.setAttribute('webkit-playsinline', true)
      video.setAttribute('x5-video-player-type', 'h5-page')
    }
  }

  // 暂停播放
  handleVideoPause() {
    const videoTag = document.querySelector(`#${this.props['customAttributes']['data-component-id']}`).getElementsByTagName('video');
    const video = videoTag && videoTag[0];
    if (video) {
      video.pause();
    }
  }

  // 继续播放
  handleVideoPlay() {
    const videoTag = document.querySelector(`#${this.props['customAttributes']['data-component-id']}`).getElementsByTagName('video');
    const video = videoTag && videoTag[0];
    if (video) {
      video.play();
    }
  }

  render() {    
    const { baseConfig } = this.props.config;
    const videoInfo = this.props.config.video;
    return (
      <div
        ref={ele => {
          if (ele) {
            this.props.exp && this.props.exp(ele);
          }
        }}
        data-dot={JSON.stringify(utils.getExposureData(this.props))}
        className="pipeline-video"
        {...this.props['customAttributes']}
        style={{
          paddingTop: this.state.isFullScreen ? '0' : `${px2rem(baseConfig.moduleMarginTop + 'px')}`,
          marginTop: baseConfig.moduleMarginTop < 0 ? `${px2rem(baseConfig.moduleMarginTop + 'px')}` : 0,
          marginLeft: 'auto',
          marginRight: 'auto',
          marginBottom: this.props.showCompMarginBottom ? '8px' : '0px',
          width: baseConfig.width,
          height: baseConfig.height,
          overflow: 'hidden',
        }}
      >
        <div className="video-wrap" id={this.props['customAttributes']['data-component-id']}></div>
      </div>
    );
  }
}

PipelineVideo.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineVideo };
export default PipelineVideo;



// WEBPACK FOOTER //
// ./components/pipeline-video/index.js